import React from 'react';
import Typography from '@/components/shared/typography/typography.component';

interface CarInfoProps {
    data: React.ReactNode[];
    IS_DESKTOP?: boolean;
}

const CarDetailsSection = ({ data, IS_DESKTOP = false }: CarInfoProps) => {
    if (!Array.isArray(data) || data.length === 0) return null;
    return (
        <div
            className={`flex items-center flex-wrap gap-y-1.5 mt-2 ${
                IS_DESKTOP ? 'gap-[10px]' : 'gap-[6px]'
            }`}
        >
            {data.map((item, index) => (
                <React.Fragment key={index}>
                    {typeof item !== 'string' ? (
                        item
                    ) : (
                        <Typography
                            variant={IS_DESKTOP ? 'body2' : 'captionMedium'}
                            className="text-gray-600"
                        >
                            {item}
                        </Typography>
                    )}
                    {index < data.length - 1 && (
                        <div className="bg-gray-500 rounded-full w-[3px] h-[3px]"></div>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default CarDetailsSection;
